/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    ADDITION: "+",
    SUBTRACTION: "-",
    CONVERSION: "conversion"
};
